module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/photo7-4-614a35b4a00a4ac436fa301b08ad48ae.png";